var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.20833C0 4.83546 0 3.64902 0.469111 2.74594C0.864425 1.98493 1.48493 1.36443 2.24594 0.969111C3.14902 0.5 4.33546 0.5 6.70833 0.5H13.2917C15.6645 0.5 16.851 0.5 17.7541 0.969111C18.5151 1.36443 19.1356 1.98493 19.5309 2.74594C20 3.64902 20 4.83546 20 7.20833V13.7917C20 16.1645 20 17.351 19.5309 18.2541C19.1356 19.0151 18.5151 19.6356 17.7541 20.0309C16.851 20.5 15.6645 20.5 13.2917 20.5H6.70833C4.33546 20.5 3.14902 20.5 2.24594 20.0309C1.48493 19.6356 0.864425 19.0151 0.469111 18.2541C0 17.351 0 16.1645 0 13.7917V7.20833Z",
    fill: "url(#paint0_linear_3254_8533)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8876 13.2795L14.332 10.5017H11.6654V8.55729C11.6654 7.77951 11.9431 7.1684 13.1654 7.1684H14.4431V4.61285C13.7209 4.50174 12.9431 4.39062 12.2209 4.39062C9.94314 4.39062 8.33203 5.77951 8.33203 8.27951V10.5017H5.83203V13.2795H8.33203V20.5017C9.44314 20.5017 10.5543 20.5017 11.6654 20.5017V13.2795H13.8876Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3254_8533",
    x1: 10,
    y1: 19.9156,
    x2: 10,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.d385dbd45d9791eb4c16e606bbc56589.svg";
export { ForwardRef as ReactComponent };